import { DescriptionInput } from './DescriptionInput';
import { DisplayNameInput } from './DisplayNameInput';

interface DisplayNameAndDescriptionInputProps {
  entityKind: string;
  displayName: string;
  setDisplayName: (name: string) => void;
  isNameInvalid?: boolean;
  nameDescription?: string;
  description: string;
  setDescription: (name: string) => void;
}

export const DisplayNameAndDescriptionInput = (
  props: DisplayNameAndDescriptionInputProps,
) => {
  const {
    entityKind,
    displayName,
    setDisplayName,
    isNameInvalid = false,
    nameDescription,
    description,
    setDescription,
  } = props;

  return (
    <>
      <DisplayNameInput
        entityKind={entityKind}
        displayName={displayName}
        setDisplayName={setDisplayName}
        isInvalid={isNameInvalid}
        description={nameDescription}
      />
      <DescriptionInput
        entityKind={entityKind}
        description={description}
        setDescription={setDescription}
      />
    </>
  );
};
